const { html } = window;

export default () => `
    <p class="message-container">
        ${html('kindleFulfillment.kindleTroubleModal.whichIssue')}
    </p>
    <div class="radio-container">
        <div class='badLink-radio'></div>
        <div class='wrongTitle-radio'></div>
        <div class='incompatibleDevice-radio'></div>
        <div class='other-radio'></div>
    </div>
    <div class='button-container'>
        <button type='button' class='submit-button button radius secondary contrast u-allCaps u-center'>${html('submit')}</button>
    </div>
`;
